import {Component, Input, OnInit, inject, DestroyRef} from '@angular/core';
import { translate } from '@jsverse/transloco';
import { ToastrService } from 'ngx-toastr';
import { CustomToastrService } from 'src/app/services/util/toastr.service';
import { DateTimeFormatService } from 'src/app/services/util/date-time-format.service';
import { UrlService } from 'src/app/services/util/url.service';
import { Subject } from 'rxjs';
import { SidenavService } from 'src/app/services/util/sidenav.service';
import { ActivatedRoute, Router } from '@angular/router';
import { InstancesService } from 'src/app/services/api/instances.service';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { SolutionsService } from 'src/app/services/api/solutions.service';
import { BreadcrumbItem } from 'src/app/models/breadcrumb/breadcrumb-item';
import { AuthService } from 'src/app/services/auth/auth.service';
import { RouterSegments } from 'src/app/models/router-segments';
import { DeployStatus } from 'src/app/models/deploy/deploy-status';
import { EndpointType } from 'src/app/models/endpoint-type';
import { ToastrErrorService } from 'src/app/services/util/toastr-error.service';
import { DeploymentClass } from 'src/app/models/instance-class';
import { SolutionVersionsInfo } from 'src/app/models/service/solution-versions-info';
import { SolutionVersionsService } from 'src/app/services/util/solution-versions.service';
import { BlueprintsService } from 'src/app/services/api/blueprints.service';
import { PermissionsService } from 'src/app/services/util/permissions.service';
import { Permission } from 'src/app/models/principal/permission';
import { Permissions, Datazone, Attributes} from 'src/app/models/principal/permission';
import { PermissionKeys } from 'src/app/models/principal/permission-keys';
import { AgentStatus } from 'src/app/models/agents/agent-status';
import { Title } from '@angular/platform-browser';
import { Instance } from 'src/app/models/instance/instance';
import { Constants } from 'src/app/models/constants';
import { animate, state, style, transition, trigger } from '@angular/animations';
import { ConfirmationDialogComponent } from 'src/app/components/confirmation-dialog/confirmation-dialog.component';
import { MatDialog } from '@angular/material/dialog';
import { DataZone } from 'src/app/models/data-zone/data-zone';
import { ErrorDialogComponent } from 'src/app/components/error-dialog/error-dialog.component';

const REQUIRED_PERMISSIONS = [
  {
    key: PermissionKeys.INSTANCE_AGENT_MANAGE_DATAZONE_NONPII,
    action: Permissions.INSTANCE_AGENT_MANAGE,
    attribute: Attributes.DATAZONE,
    attributeValue: Datazone.NONPII
  },
  {
    key: PermissionKeys.INSTANCE_AGENT_MANAGE_DATAZONE_PII,
    action: Permissions.INSTANCE_AGENT_MANAGE,
    attribute: Attributes.DATAZONE,
    attributeValue: Datazone.PII
  },
  {
    key: PermissionKeys.INSTANCE_AGENT_MANAGE_DATAZONE_LIVE,
    action: Permissions.INSTANCE_AGENT_MANAGE,
    attribute: Attributes.DATAZONE,
    attributeValue: Datazone.LIVE
  }
];
@Component({
    selector: 'app-view-instance-details',
    templateUrl: './view-instance-details.component.html',
    styleUrls: ['./view-instance-details.component.scss'],
    animations: [
        trigger('detailExpand', [
            state('collapsed', style({ height: '0px', minHeight: '0' })),
            state('expanded', style({ height: '*' })),
            transition('expanded <=> collapsed', animate('225ms cubic-bezier(0.4, 0.0, 0.2, 1)')),
        ]),
        trigger('rotate', [
            transition('void=>*', [style({ transform: 'rotate(0)' })]),
            transition('* => *', [
                style({ transform: 'rotate(0)' }),
                animate('650ms ease-in-out', style({ transform: 'rotate(360deg)' })),
            ])
        ])
    ],
    standalone: false
})
export class ViewInstanceDetailsComponent  implements OnInit {
private destroyRef = inject(DestroyRef);

  Permission = Permission;
  PermissionKeys = PermissionKeys;
  permissionsMap: { [key: string]: boolean };
  public rightExpanded: boolean;
  displayedColumns: string[] = ['subscriptionId', 'subscriptionName', 'dataZone'];
  solutionDisplayedColumns: string[] = ['name', 'value'];

  RouterSegments = RouterSegments;
  DataZone = DataZone;
  instanceId: string;
  tenantId: string;
  changeId: string;
  solutionId: string;
  data: any;
  solution: any;
  taskInfo: any;
  breadcrumbItems: BreadcrumbItem[] = [];
  isLoading = true;

  configTypeEndpoints: any;
  accessTypeEndpoints: any;
  exploreTypeEndpoints: any;
  otherTypeEndpoints: any;
  isEndpointAvailable = false;
  blueprintId: any;
  changeTaskId: string;
  serviceName: any;
  isActivityInProgress: any;
  isComponentAvailable = false;
  activeComponents: any;
  DeployStatus = DeployStatus;
  isAMR: boolean;
  viewReleaseNotes: string;
  latestReleaseVersion: any;
  devDeploymentClass = DeploymentClass.D;
  solutionVersions: any[];
  serviceVersionsInfo: SolutionVersionsInfo;
  Constants = Constants;

  AgentStatus = AgentStatus;
  count: any;

  readonly INSTANCE_DEPLOYED_STATES = [DeployStatus.DEPLOYED, DeployStatus.CONFIGURING,
    DeployStatus.CONFIGURATION_FAILED, DeployStatus.CONFIGURED, DeployStatus.UPDATING, DeployStatus.UPDATED, DeployStatus.TESTED,
    DeployStatus.UPDATE_FAILED, DeployStatus.TEST_FAILED];

  readonly INSTANCE_DEPLOYING_STATES = [DeployStatus.DEPLOYING, DeployStatus.TERMINATED,
    DeployStatus.CONFIGURING, DeployStatus.UPDATING, DeployStatus.OPERATION_INPROGRESS,
    DeployStatus.FAILOVER_APPLYING, DeployStatus.FAILBACK_APPLYING,
    DeployStatus.PRE_FAILBACK_APPLYING, DeployStatus.POST_FAILBACK_APPLYING, DeployStatus.TERMINATING, DeployStatus.TESTING, DeployStatus.INPROGRESS,];

  loaderStatus = [
    DeployStatus.DEPLOYING,
    DeployStatus.TERMINATING,
    DeployStatus.CONFIGURING,
    DeployStatus.UPDATING,
    DeployStatus.OPERATION_INPROGRESS
  ];

  statusIcons = {
    deployed: 'done',
    initialized: 'done',
    updated: 'done',
    failed: 'close',
    configuration_failed: 'close',
    terminated: 'error_outline',
    termination_failed: 'close',
    initialization_failed: 'close',
    test_failed: 'close',
    stopped: 'error_outline',
    start_failed: 'close',
    stop_failed: 'close',
    inprogress: 'change_circle',
    operation_inprogress: 'change_circle',
  };

  blueprint: any;
  readonly AGENT_STATES = [AgentStatus.RUNNING, AgentStatus.STOPPED]

  private afterClosed$ = new Subject<any>();
  constructor(public dateTimeFormatService: DateTimeFormatService, private toastrService: CustomToastrService,
    public urlService: UrlService , private sidenavService: SidenavService, private activatedRoute: ActivatedRoute,
    private instanceService: InstancesService, private solutionsService: SolutionsService, private router: Router,
    private authService: AuthService,
    private toastrErrorService: ToastrErrorService, private solutionVersionsService: SolutionVersionsService,
     private blueprintsService: BlueprintsService, private permissionsService: PermissionsService, private titleService: Title, private dialog: MatDialog) {
      
  }

  ngOnInit(): void {
    this.permissionsMap = this.permissionsService.resolveAPIPermissions(REQUIRED_PERMISSIONS);
    this.sidenavService.tenantSelectedMenu = 'TENANT_LAYOUT.MENU.DASHBOARD';
    this.instanceId = this.activatedRoute.snapshot.params.instanceId;
    this.solutionId = this.activatedRoute.snapshot.params.solutionId;
    this.blueprintId = this.activatedRoute.snapshot.params.blueprintId;
    this.changeId = this.activatedRoute.snapshot.params.changeId;
    this.tenantId = this.activatedRoute.snapshot.params.id;
    this.getInstanceDetails();
  }

  getInstanceDetails(): void {
    this.instanceService.getInstanceDetails(this.instanceId)
      .pipe(takeUntilDestroyed(this.destroyRef))
      .subscribe(data => {
        if (data) {
          this.data = data;
          this.data.solution = data;
          this.getInstanceDetailsById();
          this.getSolutionById(this.data.solutionId);
          this.getRleaseVersions(this.data.solutionId, this.solution?.latestSolutionVersionId);
          this.getBlueprint(this.blueprintId);
        }
      },
      (error) => {
        setTimeout(() => {
		      const title = translate('ERRORS.SERVICE_AVAILABILITY');
          const message = error?.message ? error?.message : (error?.error?.message ? error?.error?.message : (error?.errmsg ? error?.errmsg : translate('SERVICE.INTERNAL_SERVER_ERROR')));
          this.toastrService.errMessage(message, title);
        }, 500);
      });
  }

  getBlueprint(blueprintId): void {
    this.blueprintsService.getBlueprints()
      .pipe(takeUntilDestroyed(this.destroyRef))
      .subscribe(blueprints => {
        this.serviceName = blueprints.find(item => item.id === blueprintId)?.name;
        this.blueprint = blueprints.find(item => item.id === blueprintId);
        this.breadcrumbItems = [];
        this.breadcrumbItems.push(
          {label: translate('TENANT_LAYOUT.MENU.DASHBOARD'), url: [RouterSegments.TENANT, this.tenantId, RouterSegments.DASHBOARD]},
          {label: this.serviceName},
          {label: this.data?.name}
        )
        this.isLoading = false;
      }, (error) => {
        setTimeout(() => {
		      const title = translate('ERRORS.SERVICE_AVAILABILITY');
          const message = error?.message ? error?.message : (error?.error?.message ? error?.error?.message : (error?.errmsg ? error?.errmsg : translate('SERVICE.INTERNAL_SERVER_ERROR')));
          this.toastrService.errMessage(message, title);
        }, 500);
      });
  }

  getInstanceDetailsById(): void {
    this.instanceService.getInstanceDetailsById(this.data?.id)
      .pipe(takeUntilDestroyed(this.destroyRef))
      .subscribe(data => {
        if (data) {
          this.data.details = data;
          this.serviceVersionsInfo = this.solutionVersionsService.getSolutionVersionsInfo(this.solution, this.solutionVersions, data);
          const liveInstance = this.data.details.find(instance => instance.deploymentClass === DeploymentClass.A);
            if (liveInstance) {
              this.latestReleaseVersion = this.solutionVersions.filter(version =>
                version.id === liveInstance.solutionVersionId)[0]?.releaseVersion;
            } else {
              const instanceLength = data.length;
              const latestInstanceSolutionVersion = data[instanceLength - 1]?.solutionVersionId;
              this.latestReleaseVersion = this.solutionVersions.filter(version =>
                version.id === latestInstanceSolutionVersion)[0]?.releaseVersion;
            }

          let releaseVersionText;
            if (this.latestReleaseVersion) {
              releaseVersionText = this.latestReleaseVersion;
            } else {
              releaseVersionText = this.serviceVersionsInfo?.currentVersion?.releaseVersion;
            }
            this.isAMR = releaseVersionText && this.solutionVersionsService.releaseVersion(releaseVersionText) ? true : false;
        }
      },
      (error) => {
        // this.toastrService.clear();
      // setTimeout(() => {
      //   this.toastrService.errorMessage(
      //     `${error?.message ? error?.message : (error?.error?.message ? error?.error?.message
      //       : (error?.errmsg ? error?.errmsg : translate('SERVICE.INTERNAL_SERVER_ERROR')))}`
      //     );
      // }, 500);
      });
  }

  getSolutionById(solutionId): void {
    this.solutionsService.getSolutionById(solutionId)
    .pipe(takeUntilDestroyed(this.destroyRef))
    .subscribe(result => {
      this.solution = result;
    },
    (error) => {
        setTimeout(() => {
		      const title = translate('ERRORS.SERVICE_AVAILABILITY');
          const message = error?.message ? error?.message : (error?.error?.message ? error?.error?.message : (error?.errmsg ? error?.errmsg : translate('SERVICE.INTERNAL_SERVER_ERROR')));
          this.toastrService.errMessage(message, title);
        }, 500);
    });
  }

  getRleaseVersions(solutionId,targetSolutionVersionId): void {
    if(targetSolutionVersionId) {
      this.solutionsService.getSolutionVersion(solutionId, targetSolutionVersionId)
      .pipe(takeUntilDestroyed(this.destroyRef))
      .subscribe(task => {
        this.taskInfo = task;
        this.latestReleaseVersion = task.releaseVersion;
      },
      (error) => {
        setTimeout(() => {
		      const title = translate('ERRORS.SERVICE_AVAILABILITY');
          const message = error?.message ? error?.message : (error?.error?.message ? error?.error?.message : (error?.errmsg ? error?.errmsg : translate('SERVICE.INTERNAL_SERVER_ERROR')));
          this.toastrService.errMessage(message, title);
        }, 500);
      });
    }
  }

  navigateToChangeTask(event): void {
    this.router.navigate(['/', this.authService.principal.provider, RouterSegments.TENANT, this.tenantId, RouterSegments.CONTINUOUS_UPDATE,
      event?.taskInfo.solutionId, this.instanceId, this.changeTaskId, RouterSegments.INSTANCE
    ]);
  }

  goToInstances(): void {
    this.router.navigate(['/', this.authService.principal.provider, RouterSegments.TENANT, this.tenantId, RouterSegments.DASHBOARD]);
  }

  breadcrumbs(): void {
    this.breadcrumbItems = [];
    this.breadcrumbItems.push({icon: 'assets/images/home_icon.svg'},
      {label: translate('LEFT_SIDE_NAV.CONTINUOUS_UPGRADE')},
      {label: translate('LEFT_SIDE_NAV.SOLUTIONS'), url: ['updates-solution']},
      {label: (this.solution?.name ? this.solution?.name : '') + ' - ' + translate('LEFT_SIDE_NAV.VIEW_TENANTS'),
      url: [RouterSegments.SOLUTIONS, this.solutionId]},
      {label: this.taskInfo?.tenantId ? this.taskInfo?.tenantId : '', url: [RouterSegments.SOLUTIONS,
         this.solutionId, this.blueprintId, this.changeId, this.tenantId, RouterSegments.INSTANCE]},
      {label: this.data.name});
  }

  closeSidenav(): void {
    this.sidenavService.closeRightSidenav();
  }


  displayAgentStatus(agentStatus?: any): string {
    if (agentStatus === 'running') {
      return 'Stop Agent';
    } else {
      return 'Start Agent';
    }
  }

    /**
   * Changing agent status corresponding to given configuration id
   * @param - the configuration id
   */
    refreshInstances(): void {
      this.isLoading = true;
      this.count = this.count !== 1 ? 1 : 0;
      this.getInstanceDetails();
    }

    changeAgentStatus(data?: Instance): void {
      if ((this.data?.dataZone === DataZone.DEVELOPMENT && !this.permissionsMap[PermissionKeys.INSTANCE_AGENT_MANAGE_DATAZONE_NONPII]) || (this.data?.dataZone === DataZone.SECURE && !this.permissionsMap[PermissionKeys.INSTANCE_AGENT_MANAGE_DATAZONE_PII]) ||
        (this.data?.dataZone === DataZone.LIVE && !this.permissionsMap[PermissionKeys.INSTANCE_AGENT_MANAGE_DATAZONE_LIVE])) {
        return;
      }
      if (data.agentStatus === this.AgentStatus.RUNNING)
        this.dialog.open(ConfirmationDialogComponent, {
          panelClass: 'default-dialog-wrapper',
          width: '566px',
          autoFocus: false,
          data: {
            title: translate('INSTANCE_DETAILS.AGENT_STOP_TITLE'),
            message: translate('INSTANCE_DETAILS.AGENT_STOP_DESC'),
            confirmButtonText: translate('BUTTONS.SUBMIT')
          }
        })
          .afterClosed()
          .pipe(takeUntilDestroyed(this.destroyRef))
          .subscribe(confirm => {
            if (confirm) {
        this.instanceService.agentStop(data)
          .pipe(takeUntilDestroyed(this.destroyRef))
          .subscribe({
            complete: () => {
              this.getInstanceDetails();
            setTimeout(() => {
              const title = translate('INSTANCE_DETAILS.INSTANCE_DETAILS'); 
              const message = translate('INSTANCE_SUMMARY.TOOLTIP.AGENT_STATUS_SUCCESS');
              this.toastrService.successMessage(message, title);
            }, 500);
            },
            error: (error) => {
              const errorMessage = typeof error === 'string' ? error: typeof error?.error === 'string' ? error.error : error;
                this.dialog.open(ErrorDialogComponent, {
                  minHeight: '342px',
                  width: '566px',
                  panelClass: 'flex-dialog',
                  data: {
                    title: translate('ERROR_DIALOG.AGENT_STOP_FAILED'),
                    description: errorMessage,
                  }
               });
            }
          });
        }
      });
  
      if (data.agentStatus === this.AgentStatus.STOPPED)
        this.dialog.open(ConfirmationDialogComponent, {
          panelClass: 'default-dialog-wrapper',
          width: '566px',
          autoFocus: false,
          data: {
            title: translate('INSTANCE_DETAILS.AGENT_START_TITLE'),
            message: translate('INSTANCE_DETAILS.AGENT_START_DESC'),
            confirmButtonText: translate('BUTTONS.SUBMIT')
          }
        })
          .afterClosed()
          .pipe(takeUntilDestroyed(this.destroyRef))
          .subscribe(confirm => {
            if (confirm) {
        this.instanceService.agentStart(data)
          .pipe(takeUntilDestroyed(this.destroyRef))
          .subscribe({
            complete: () => {
              this.getInstanceDetails();
            setTimeout(() => {
              const title = translate('INSTANCE_DETAILS.INSTANCE_DETAILS');
              const message = translate('INSTANCE_SUMMARY.TOOLTIP.AGENT_STATUS_SUCCESS');
              this.toastrService.successMessage(message, title);
            }, 500);
            },
            error: (error) => {
              const errorMessage = typeof error === 'string' ? error: typeof error?.error === 'string' ? error.error : error;
                this.dialog.open(ErrorDialogComponent, {
                  minHeight: '342px',
                  width: '566px',
                  panelClass: 'flex-dialog',
                  data: {
                    title: translate('ERROR_DIALOG.AGENT_START_FAILED'),
                    description: errorMessage,
                  }
               });
            }
          });
        }
      });
    }



  onLogDataChange(data): void {
    this.instanceService.sendingLogBasedOnSelection(data)
    .subscribe((error)=>{
        const errorMessage = typeof error === 'string' ? error: typeof error?.error === 'string' ? error.error : error;
        this.dialog.open(ErrorDialogComponent, {
          minHeight: '342px',
          width: '630px',
          panelClass: 'flex-dialog',
          data: {
            title: translate('ERROR_DIALOG.EDIT_DATE_FAILED'),
            description: errorMessage
          }
        });
     });
  }

}
